// extracted by mini-css-extract-plugin
module.exports = {"box":"style_box__6ZCCS","restaurantInfo":"style_restaurantInfo__8HjNP","mainBoxStyle":"style_mainBoxStyle__VZikY","loginModalStyle":"style_loginModalStyle__BGqZQ"};